module.exports = __webpack_public_path__ + "static/Cisco-Meraki-1eea7a387ce439f579db0a38f818b418.png";